export default __webpack_public_path__ + "static/media/101.a746af2a.png";